import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { PlayerIcon } from '@/enums/player-icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPlayerWrapper',
  props: {
    isActive: { type: Boolean, default: false },
    isBackdrop: { type: Boolean, default: false },
    playIconType: { default: null },
    isDisneyPlusOffer: { type: Boolean, default: false },
    isDMTitleTrailer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { isActive: boolean, isBackdrop: boolean, playIconType: PlayerIcon | null, isDisneyPlusOffer: boolean, isDMTitleTrailer?: boolean };



const formattedPlayIconType = computed<PlayerIcon>(() => {
	if (props.playIconType) {
		return props.playIconType;
	}
	return props.isBackdrop ? PlayerIcon.JUSTWATCH : PlayerIcon.YOUTUBE;
});

const playIcon = computed(() => {
	const extension = formattedPlayIconType.value === PlayerIcon.YOUTUBE ? 'png' : 'svg';
	return `url(/${ASSETS_DIR}/img/${formattedPlayIconType.value}-icon-play.${extension})`;
});

return { __sfc: true,props, formattedPlayIconType, playIcon }
}

})